/*
* Created on Jan 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React from 'react';

const OrgContentPlaceholderComponent = ({show_partial=false}) => {
    return (
        <div className="content content-page">
            {!show_partial &&
                <div className="content-title">
                    <div className="comp-placeholder placeholder-img !mr-10"></div>
                    <div className="comp-placeholder placeholder-title"></div>
                </div>
            }
            {!show_partial &&
                <div className="toolbar">
                    <div className="col-wrapper">
                        <div className="col-left">
                            <div className="comp-placeholder placeholder-btn !mr-8"></div>
                            <div className="comp-placeholder placeholder-btn"></div>
                        </div>
                        <div className="col-right">
                            <div className="comp-placeholder placeholder-search"></div>
                        </div>
                    </div>
                </div>
            }
            <div className="content-wrapper page-wrapper">
                <div className="comp-placeholder placeholder-text-full"></div>
                <div className="comp-placeholder placeholder-text-full"></div>
                <div className="comp-placeholder placeholder-text-full"></div>
                <div className="comp-placeholder placeholder-text-full"></div>
                <div className="comp-placeholder placeholder-text-full"></div>
                <div className="comp-placeholder placeholder-text-three-quarters"></div>
                <div className="comp-placeholder placeholder-text-three-quarters"></div>
            </div>
        </div>
    );
};

export default OrgContentPlaceholderComponent;